import { RestProduct } from "../types/product";
import { Money } from "../types/money";
import { RestModifier } from "../types/modifier";
import { ProductVariant } from "../types/productVariant";
import { createProductFromVariant } from "./productVariant";

export const resolveCartLinePricing = ({
  product,
  isTakeaway,
  explicitUnitPrice,
  variant,
}: {
  product: RestProduct;
  isTakeaway: boolean;
  explicitUnitPrice?: Money | null;
  variant?: ProductVariant | null;
}) => {
  const effectiveProduct = variant
    ? createProductFromVariant(product, variant)
    : product;
  if (!isTakeaway) {
    return {
      unitPrice: explicitUnitPrice ?? effectiveProduct.unitPrice,
      VAT: effectiveProduct.VAT,
      bookkeepingAccountId: effectiveProduct.bookkeepingAccountId ?? null,
    };
  }

  const takeawayPrice = effectiveProduct.takeawayPrice;
  const unitPrice =
    explicitUnitPrice ?? takeawayPrice ?? effectiveProduct.unitPrice;

  const VAT = effectiveProduct.takeawayVAT ?? product.VAT;

  const bookkeepingAccountId =
    effectiveProduct.takeawayBookkeepingAccountId ??
    effectiveProduct.bookkeepingAccountId ??
    null;

  return { unitPrice, VAT, bookkeepingAccountId };
};

export const resolveModifierPricing = ({
  modifier,
  isTakeaway,
}: {
  modifier: RestModifier;
  isTakeaway: boolean;
}) => {
  if (!isTakeaway) {
    return {
      unitPrice: modifier.price,
      VAT: modifier.VAT,
      bookkeepingAccountId: modifier.bookkeepingAccountId,
    };
  }

  const unitPrice = modifier.takeawayPrice ?? modifier.price;
  const VAT = modifier.takeawayVAT ?? modifier.VAT;
  const bookkeepingAccountId =
    modifier.takeawayBookkeepingAccountId ??
    modifier.bookkeepingAccountId ??
    null;

  return { unitPrice, VAT, bookkeepingAccountId };
};

export const isModifierInternal = (modifier: {
  unitPrice?: Money | null;
  internal?: boolean | null;
}) => {
  if (modifier.unitPrice && modifier.unitPrice.amount !== 0) {
    return false;
  }

  return modifier.internal ?? false;
};
